// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CompareNamesResponse } from '@coa/app/shared/select-items-shared/models/compare-stores.response';
import { Observable } from 'rxjs';
import { ConfigService } from '@coa/app/core/services/config.service';
import { SelectableFeature } from '@coa/app/shared/select-items-shared/models/selectable-feature';

@Injectable({
  providedIn: 'root',
})
export class CompareFooterService {
  paths = {
    'floors': '/locations/floors',
    'groups': '/dynamic-groups/all',
    'stores': '/stores',
  };

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getNames(clientId: string, selectableFeature: SelectableFeature): Observable<CompareNamesResponse> {
    const url = this.configService.getConfig().analyticsApi + this.paths[selectableFeature];
    const params = new HttpParams()
      .set('clientId', clientId.toString());
    return this.httpClient.get<CompareNamesResponse>(url, {params});
  }
}
